module.exports = __webpack_public_path__ + "img/review.63b2bcd2.svg";